"use client";

import { useState } from "react";
import { StockBrokingTopBar } from "@/components/demos/stock-broking/StockBrokingTopBar";
import { StockBrokingHero } from "@/components/demos/stock-broking/StockBrokingHero";
import { StockBrokingServicesSection } from "@/components/demos/stock-broking/StockBrokingServicesSection";
import { StockBrokingTrustSection } from "@/components/demos/stock-broking/StockBrokingTrustSection";
import { AccountProposalModal } from "@/components/demos/stock-broking/AccountProposalModal";
import { DemoCommercialBanner } from "@/components/demos/DemoCommercialBanner";

export default function StockBrokingPortalPage() {
  const [modalPlan, setModalPlan] = useState<string | null>(null);

  return (
    <main className="min-h-screen flex flex-col bg-slate-50">
      <StockBrokingTopBar />

      <StockBrokingHero onOpenAccount={(planId) => setModalPlan(planId)} />

      <DemoCommercialBanner
        accent="emerald"
        badge="Live Interactive Broking Demo"
        title="This entire broking website + CRM was built by Johnson Softwares."
        description="From the client onboarding portal to the SEBI-compliant Relationship Manager pipeline — a complete demat account-opening engine with WhatsApp, telephony and MIS, tailored to your brokerage."
        targetUrl="/demos/stock-broking/crm"
        targetLabel="Open the Broking CRM"
        secondaryUrl="/contact"
        secondaryLabel="Build mine"
      />

      <StockBrokingServicesSection onSelectPlan={(planId) => setModalPlan(planId)} />

      <StockBrokingTrustSection />

      <footer className="bg-slate-50 border-t border-slate-200 py-10 px-4 text-center text-xs text-slate-500">
        <p className="text-slate-500 font-medium">
          Johnson Securities (Demo) · NSE · BSE · MCX · NSDL Member · Prestige Tech Park, Bengaluru 560103
        </p>
        <p className="mt-1">
          Investments in securities market are subject to market risks. Read all related documents carefully before investing. · Illustrative demo by Johnson Softwares.
        </p>
      </footer>

      <AccountProposalModal
        isOpen={modalPlan !== null}
        planId={modalPlan ?? "value"}
        onClose={() => setModalPlan(null)}
      />
    </main>
  );
}
